import React from 'react';
import Svg, { Path } from 'react-native-svg';
const BarChart = (props) => (<Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path d="M5.7002 20.3996V14.0996" stroke={props.color ?? '#8F95B2'} strokeWidth="2.7" strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M18.2999 20.4004V9.90039" stroke={props.color ?? '#8F95B2'} strokeWidth="2.7" strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M12 20.3996V3.59961" stroke={props.color ?? '#8F95B2'} strokeWidth="2.7" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default BarChart;
